import { Modal, Typography } from "antd";
import { InfoCircleOutlined } from "@ant-design/icons";

const { Title, Paragraph } = Typography;

export default function ConfirmationModal({
  open,
  relationModalDecision,
  onClose,
  btnLoading,
  hours,
}) {
  return (
    <Modal
      centered
      mask={false}
      open={open}
      onOk={() => {
        relationModalDecision();
      }}
      onCancel={onClose}
      closable={false}
      className="post-confirmation-modal"
      okText="Yes, Post"
      cancelText="No, Edit"
      cancelButtonProps={{
        ghost: true,
      }}
      okButtonProps={{
        loading: btnLoading,
      }}
    >
      <InfoCircleOutlined />
      <Title level={4}>Confirmation</Title>
      <Paragraph className="text">
        {`   This will be posted to the Journal and neither you nor your
        co-Journalist will be able to create a new entry for ${hours} minute${hours > 1 ? "s" : ""
          }. This is
        designed to allow both parties to digest what has been said and respond
        accordingly.`}
      </Paragraph>
      <Paragraph className="text">
        Are you ready to post this journal entry?
      </Paragraph>
    </Modal>
  );
}
